<template lang="">
  <div class="mx-7">
    <div class="my-6 d-flex justify-end align-end">
      <v-btn
        v-if="
          ($auth.policies['add-period-head-fee'] && router === 'normal' && !isSubFee) ||
            ($auth.policies['add-period-dedution'] && router === 'priority' && !isSubFee) ||
            ($auth.policies['add-period-arrear-fee'] && router === 'normal' && isSubFee) ||
            ($auth.policies['add-period-refund-fee'] && router === 'priority' && isSubFee)
        "
        depressed
        color="primary"
        @click="createDialog = !createDialog"
      >
        <v-icon left>add</v-icon>
        {{ `Thêm kỳ ${titleType}` }}
      </v-btn>
    </div>
    <v-data-table
      mobile-breakpoint="0"
      :items-per-page="5"
      item-key="id"
      :headers="headers"
      :items="groupHeadFeePrice"
      loading-text="Đang Tải"
      :footer-props="footerTable"
      sort-by="title"
      color="transparent"
      class="wrap-dddd"
    >
      <template v-slot:no-data>
        <div class="my-16 font-weight-bold">
          <p>Hiện tại chưa có kỳ {{ titleType }} trong danh sách.</p>
          <p>Vui lòng thực hiện thao tác thêm kỳ {{ titleType }} ở phía trên.</p>
        </div>
      </template>
      <template v-slot:[`footer.page-text`]="items">
        {{ items.pageStart }} - {{ items.pageStop }} trên {{ items.itemsLength }}
      </template>
      <template v-slot:item.price="{ item }">
        <a v-if="groupHeadFee.scope === 'select'" @click="$refs['dialog-excel-payment'].openDialog(item)"
          >Xem chi tiết</a
        >
        <span v-else>{{ item.price.toLocaleString('en-US') }}{{ item.type === 'percentage' ? '%' : ' VNĐ' }}</span>
      </template>
      <template v-slot:item.period.title="{ item }"> {{ item.period.title | convertFullDate }} </template>
      <template v-slot:item.action="{ item }" class="text-center">
        <v-btn
          class="elevation-0"
          icon
          @click="$refs['dialog-excel-payment'].openDialog(item)"
          v-if="groupHeadFee.scope === 'select'"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn
          class="elevation-0"
          icon
          @click="$refs['dialog-update-price-note'].openDialog(item)"
          v-if="groupHeadFee.scope === 'select'"
        >
          <v-icon>mdi-note</v-icon>
        </v-btn>
        <v-btn class="elevation-0" icon @click="updatePrice(item.id)" v-if="groupHeadFee.scope === 'group'">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>

        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-if="
                ($auth.policies['delete-period-head-fee'] && router === 'normal' && !isSubFee) ||
                  ($auth.policies['delete-period-dedution'] && router === 'priority' && !isSubFee) ||
                  ($auth.policies['delete-period-arrear-fee'] && router === 'normal' && isSubFee) ||
                  ($auth.policies['delete-period-refund-fee'] && router === 'priority' && isSubFee)
              "
              v-bind="attrs"
              v-on="on"
              icon
            >
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item>
              <v-list-item-title class="red--text accent-2" style="cursor: pointer" @click="deletePriceDialog(item.id)"
                ><v-icon color="red accent-2">mdi-delete-outline</v-icon> Xóa kỳ {{ titleType }}</v-list-item-title
              >
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
    <paymentPeriodByAllNewDialog
      :state="createDialog"
      :groupHeadFee="groupHeadFee"
      :prices="groupHeadFeePrice"
      style="margin: 0 20px"
    />
    <paymentPeriodByAllUpdateDialog
      :state="updateDialog"
      :groupHeadFee="groupHeadFee"
      :prices="groupHeadFeePrice"
      style="margin: 0 20px"
      v-if="groupHeadFee.scope === 'group'"
    />
    <ImportExcelPaymentPeriodDialog ref="dialog-excel-payment" style="margin: 0 20px" />
    <PriceNoteUpdateDialog ref="dialog-update-price-note" />
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { sortPeriod } from './helper/period'
import paymentPeriodByAllNewDialog from './paymentPeriodByAllNewDialog.vue'
import paymentPeriodByAllUpdateDialog from './paymentPeriodByAllUpdateDialog.vue'
import PriceNoteUpdateDialog from './priceNoteUpdateDialog.vue'
import ImportExcelPaymentPeriodDialog from '@/modules/tuitionFee/head-fee/ImportExcelPaymentPeriodDialog/ImportExcelPaymentPeriodDialog.vue'
import { headerPaymentPeriodTable } from '@/modules/tuitionFee/head-fee/helper/headerHelper'

export default {
  components: {
    paymentPeriodByAllNewDialog,
    paymentPeriodByAllUpdateDialog,
    ImportExcelPaymentPeriodDialog,
    PriceNoteUpdateDialog
  },
  props: {
    paymentPeriod: Array,
    groupHeadFee: Object
  },
  created() {
    this.getGroupHeadFeePrice()
  },
  data() {
    return {
      headFeeTableOptions: {},
      changeClass: false,
      dialog: false,
      createDialog: false,
      updateDialog: false,
      tableOptions: {},
      groupHeadFeePrice: []
    }
  },
  computed: {
    ...mapState('tuitonFeePrice', ['tuitionFeePrices', 'price']),
    ...mapState('tuitonFeeHeadFee', ['router', 'isSubFee']),
    titleType() {
      if (this.$route.name === 'head-fees') return 'đóng'
      return this.$route.meta.title.replace('Chi tiết khoản', '')
    },
    footerTable() {
      let footer = {
        'items-per-page-text': `Kỳ ${this.titleType} mỗi trang`,
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 5
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    },
    groupHeadFeeId() {
      return this.groupHeadFee.id
    },
    headers() {
      return headerPaymentPeriodTable(this.router, this.isSubFee)
    }
  },
  methods: {
    ...mapActions('tuitonFeePrice', ['setTuitionFeePrice', 'getPriceById', 'deletePrice']),
    ...mapActions('tuitonFeeHeadFee', ['deletePriceGroupHeadFee', 'getGroupHeadFeeByHeadFee']),
    ...mapActions('tuitionFeePeriod', ['fetchPeriod']),
    getGroupHeadFeePrice() {
      this.groupHeadFeePrice = sortPeriod(this.groupHeadFee.prices)
    },
    async updatePrice(id) {
      this.updateDialog = !this.updateDialog
      this.getPriceById(id)
    },
    deletePriceDialog(idPrice) {
      this.$dialog.confirm({
        title: `Xác nhận xóa kỳ ${this.titleType}?`,
        text: `<div>Thao tác này sẽ không thể hoàn tác.<br/> Bạn có chắc chắn muốn xoá kỳ ${this.titleType}?</div>`,
        okText: 'XOÁ',
        type: 'delete',
        cancelText: 'HUỶ',
        done: async () => {
          try {
            let payload = {
              groupHeadFeeId: this.groupHeadFee.id,
              idPrice
            }
            await this.deletePriceGroupHeadFee(payload)
            await this.getGroupHeadFeeByHeadFee(this.$route.params.id)
            this.$alert.deleteSuccess(`kỳ ${this.titleType}`)
          } catch (e) {
            this.$alert.deleteError({
              title: 'Lỗi thao tác',
              description: `Không thể xóa kỳ ${this.titleType}. Vui lòng thử lại`
            })
          }
        }
      })
    }
  },
  watch: {
    groupHeadFee() {
      this.groupHeadFeePrice = this.groupHeadFee.prices
      this.getGroupHeadFeePrice()
    }
  }
}
</script>
<style lang="scss" scoped>
.wrap-dddd {
  border: 1px solid #d9d8d8;
}
</style>
